/**
 * 🗄️ Database Service
 * Service layer for database API calls
 */

import { api } from '@/lib/api';
import type {
  DatabaseResponse,
  DatabaseListResponse,
  CreateDatabaseRequest,
  UpdateDatabaseRequest,
  DatabaseQuery,
} from '@troia-v3/types';

export const databaseService = {
  /**
   * Get all databases
   */
  async getDatabases(query?: DatabaseQuery): Promise<DatabaseListResponse> {
    const response = await api.get('/databases', { params: query });
    // Backend retorna { success: true, data: { items: [...], total, page, limit, totalPages } }
    return response.data.data;
  },

  /**
   * Get database by ID
   */
  async getDatabaseById(id: string): Promise<DatabaseResponse> {
    const response = await api.get(`/databases/${id}`);
    return response.data.data;
  },

  /**
   * Create new database
   */
  async createDatabase(data: CreateDatabaseRequest): Promise<DatabaseResponse> {
    const response = await api.post('/databases', data);
    return response.data.data;
  },

  /**
   * Update database
   */
  async updateDatabase(id: string, data: UpdateDatabaseRequest): Promise<DatabaseResponse> {
    const response = await api.patch(`/databases/${id}`, data);
    return response.data.data;
  },

  /**
   * Delete database
   */
  async deleteDatabase(id: string): Promise<void> {
    await api.delete(`/databases/${id}`);
  },
};
